export const adminMessages = {
  en: {
    admin_home: "Go to home",
    admin_host_operations: "Host Operations",
    admin_title: "Host Ops",
    admin_subtitle: "Operational controls for entitlement budgets and their reset policies.",
    admin_status_loading: "Loading",
    admin_status_active: "Active",
    admin_status_uninitialized: "Not initialized",
    admin_status_in_grace: "In grace",
    admin_status_exhausted: "Exhausted",
    admin_budget_not_initialized: "Not initialized",
    admin_status_inactive: "Inactive",
    admin_bootstrap_section: "Bootstrap",
    admin_access_checking: "Checking host admin access",
    admin_access_checking_hint:
      "Verifying whether the stored token can access host-admin operations.",
    admin_access_denied: "Host admin access required",
    admin_access_denied_hint:
      "Enter the host admin token generated during setup to unlock host-admin operations.",
    admin_bootstrap_token: "Host Admin Token",
    admin_bootstrap_token_placeholder: "Paste host admin token",
    admin_bootstrap_save: "Unlock Host Admin",
    admin_bootstrap_saved: "Host admin access unlocked",
    admin_bootstrap_clear: "Clear Host Admin Token",
    admin_bootstrap_copy: "Copy Host Admin Token",
    admin_bootstrap_token_copied: "Host admin token copied",
    admin_budget_search_placeholder: "Search budgets by label, key, or id",
    admin_budget_search_empty: "No budgets match this search.",
    admin_budget_add: "Add budget",
    admin_budget_add_confirm: "Add",
    admin_budget_new_placeholder: "Budget key",
    admin_budget_unlabeled: "Unlabeled budget",
    admin_budget_open: "Open budget admin",
    admin_budget_more_actions: "More budget actions",
    admin_budget_rename: "Rename budget",
    admin_budget_label_saved: "Budget label updated",
    admin_budget_current_remaining: "Current remaining (GiB)",
    admin_budget_remaining_override: "Override current remaining",
    admin_budget_remaining_ok: "OK",
    admin_budget_remaining_saved: "Current remaining updated",
    admin_budget_invalid_remaining: "Current remaining must be a valid non-negative GiB value",
    admin_budget_activate: "Click to enable this budget now",
    admin_budget_deactivate: "Click to disable this budget now",
    admin_budget_used_percent: "{percent}% used",
    admin_budget_used_detail: "{used} used of {total}",
    admin_budget_replenish_amount_short: "{amount} GiB",
    admin_monthly_activate: "Click to enable scheduled replenishment",
    admin_monthly_deactivate: "Click to disable scheduled replenishment",
    admin_monthly_reset_amount: "Replenish amount (GiB)",
    admin_monthly_invalid_reset_amount: "Reset amount must be a valid non-negative GiB value",
    admin_monthly_cron_expr: "Cron expression",
    admin_monthly_next_reset_tooltip: "Next reset: {time}",
    admin_monthly_next_reset_unscheduled: "No reset currently scheduled",
    admin_monthly_save: "Save Replenishment Policy",
    admin_monthly_saved: "Budget replenishment policy updated",
    admin_budget_admin_token_copy: "Copy Budget Admin Token",
    admin_budget_default: "Default",
    admin_budget_archive: "Archive budget",
    admin_budget_archive_confirm:
      "Archive this budget? This removes it from the admin list, revokes tracked tokens and budget-admin access, and disables it immediately.",
    admin_budget_archived: "Budget archived",
    admin_copy_token: "Copy Token",
    admin_reveal_token: "Reveal Token",
    admin_hide_token: "Hide Token",
    admin_token_minted: "Budget admin token minted",
    admin_token_copied: "Token copied",
    admin_token_copy_failed: "Could not copy token",
    admin_not_loaded: "Not loaded yet",
    budget_admin_kicker: "Budget Administration",
    budget_admin_back_to_host_admin: "Back to Host Admin",
    budget_admin_access_hint: "Enter a budget admin token to manage this budget.",
    budget_admin_token_placeholder: "Paste budget admin token",
    budget_admin_unlock: "Unlock Budget Admin",
    budget_admin_unlocked: "Budget admin access unlocked",
    budget_admin_mint_entitlement: "Mint Service Entitlement Token",
    budget_admin_create_token: "Create token",
    budget_admin_token_preview_unavailable: "Token unavailable",
    budget_admin_entitlement_minted: "Service entitlement token minted",
    budget_admin_token_list_title: "Entitlement tokens",
    budget_admin_token_list_subtitle:
      "These are the service-access tokens this budget issues. Label them and turn them on or off individually.",
    budget_admin_token_delete: "Delete token",
    budget_admin_token_deleted: "Token deleted",
    budget_admin_no_tokens: "No entitlement tokens yet.",
    budget_admin_token_label_placeholder: "Token label",
    budget_admin_token_label_saved: "Token label updated",
    budget_admin_token_enable_tooltip: "Click to activate token",
    budget_admin_token_disable_tooltip: "Click to deactivate token",
    budget_admin_meter_at_token_level_on: "Track usage per token",
    budget_admin_meter_at_token_level_off: "Per-token tracking off",
    budget_admin_resets: "Resets {date}",
    budget_admin_token_used: "{amount} this period",
  },
} as const
